export default defineNuxtPlugin(async () => {
  // Only run if we're in a Capacitor environment
  if (typeof window === 'undefined') return

  // Dynamically import Capacitor modules only when they're available
  const { Capacitor } = await import('@capacitor/core')

  if (!Capacitor.isNativePlatform()) {
    console.log('Running in web environment - Capacitor plugins not available')
    return
  }

  // Only import and use Capacitor plugins in native environment
  const [
    { App },
    { StatusBar, Style },
    { SplashScreen },
    { Keyboard, KeyboardResize }
  ] = await Promise.all([
    import('@capacitor/app'),
    import('@capacitor/status-bar'),
    import('@capacitor/splash-screen'),
    import('@capacitor/keyboard')
  ])

  const initializeCapacitor = async () => {
    try {
      await StatusBar.setStyle({ style: Style.Dark })
      await StatusBar.setBackgroundColor({ color: '#1b252b' })

      await Keyboard.setAccessoryBarVisible({ isVisible: false })
      await Keyboard.setResizeMode({ mode: KeyboardResize.Body })

      await SplashScreen.hide()

      App.addListener('backButton', ({ canGoBack }) => {
        if (!canGoBack) {
          App.exitApp()
        } else {
          window.history.back()
        }
      })

      console.log('Capacitor plugins initialized successfully')
    } catch (error) {
      console.warn('Error initializing Capacitor plugins:', error)
    }
  }

  await initializeCapacitor()
})
